console.log("Location Filter Engine Loaded");

const LOCATION_KEYWORDS = {

    outdoor: [
        "outdoor",
        "garden",
        "yard",
        "backyard",
        "terrace",
        "parking",
        "gate",
        "entrance"
    ],

    indoor: [
        "indoor",
        "home",
        "bedroom",
        "living room",
        "office",
        "shop"
    ]

};

function detectRequestedLocation(message){

    message = message.toLowerCase();

    for(const location in LOCATION_KEYWORDS){

        const keywords = LOCATION_KEYWORDS[location];

        for(const keyword of keywords){

            if(message.includes(keyword)){

                return location;

            }

        }

    }

    return null;

}

function detectProductLocation(product){

    //----------------------------------------
    // USE STRONG PRODUCT IDENTIFIERS
    //----------------------------------------

    const title = (
        product.title || ""
    ).toLowerCase();

    const productType = (
        product.product_type || ""
    ).toLowerCase();

    const tags = (
        product.tags || []
    ).join(" ").toLowerCase();


    //----------------------------------------
    // COMBINE STRONG DATA ONLY
    //----------------------------------------

    const strongText =
        title + " " +
        productType + " " +
        tags;


    //----------------------------------------
    // EXPLICIT INDOOR PRODUCTS
    //----------------------------------------

    if(
        strongText.includes("indoor") ||
        strongText.includes("baby monitor") ||
        strongText.includes("home monitor") ||
        strongText.includes("bulb camera")
    ){

        return "indoor";

    }


    //----------------------------------------
    // EXPLICIT OUTDOOR PRODUCTS
    //----------------------------------------

    if(
        strongText.includes("outdoor") ||
        strongText.includes("weatherproof") ||
        strongText.includes("waterproof")
    ){

        return "outdoor";

    }


    //----------------------------------------
    // UNKNOWN
    //----------------------------------------

    return null;

}


function filterProductsByLocation(products, location){

    if(!location){

        return products;

    }

    return products.filter(product => {

        return detectProductLocation(product) === location;

    });

}